<template>
    <div class="choose-section pt-100 pb-70">
        <div class="container">
            <div class="section-title">
                <small>{{ $t('aboutUs.whyChoose.subtitle') }}</small>
                <h2>{{ $t('aboutUs.whyChoose.title') }}</h2>
                <p>{{ $t('aboutUs.whyChoose.description') }}</p>
            </div>
            <div class="process-content">
                <div class="row justify-content-center">
                    <div
                        class="col-md-6 col-lg-4 pb-30"
                        style="display: flex;"
                        v-for="(item, index) in whyChooseItems"
                        :key="item.title"
                    >
                        <div class="process-item process-item-center border" style="flex:1">
                            <div class="process-thumb">
                                <img v-lazy="itemImage(item.image)" :class="thumbClasses[index]" :alt="item.title">
                            </div>
                            <div class="process-text">
                                <h3>{{ item.title }}</h3>
                                <p>{{ item.description }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WhyChooseUs',
    computed: {
        whyChooseItems() {
            const data = this.$t('aboutUs.whyChoose.items')
            return Array.isArray(data) ? data : []
        },
        thumbClasses() {
            return ['one', 'two', 'three']
        }
    },
    methods: {
        itemImage(imageName) {
            if (!imageName) return ''
            return this.$ossImg(imageName)
        }
    }
}
</script>
<style scoped>
.process-item {
    filter: drop-shadow(0 4px 16.6px rgba(122, 151, 177, 0.25));

}
.process-item-center .process-thumb {
    height: 93px;
    /* overflow: hidden; */
}
.one {
    width: 119.211px;
    height: 119.211px;
    top: -16px;
    left: 15px;
}
.two {
    width: 93.484px;
    height: 84.382px;
    left: 26px;
}
.three {
    width: 93.003px;
    height: 93.003px;
    top: -7px;
    left: 26px;
}
</style>
